import { translationKey } from '@change-corgi/core/i18n';

export const TASKS_CONFIGS = {
	complete_profile: {
		title: translationKey('corgi.petition.starter_dashboard_v2.next_steps.tasks.complete_profile.title'),
		description: translationKey('corgi.petition.starter_dashboard_v2.next_steps.tasks.complete_profile.description'),
		primaryActionText: translationKey('corgi.petition.starter_dashboard_v2.next_steps.tasks.complete_profile.cta'),
	},
	create_petition: {
		title: translationKey('corgi.petition.starter_dashboard_v2.next_steps.tasks.create_petition.title'),
		description: translationKey('corgi.petition.starter_dashboard_v2.next_steps.tasks.create_petition.description'),
		primaryActionText: translationKey('corgi.petition.starter_dashboard_v2.next_steps.tasks.create_petition.cta'),
	},
	customize_link: {
		title: translationKey('corgi.petition.starter_dashboard_v2.next_steps.tasks.customize_link.title'),
		description: translationKey('corgi.petition.starter_dashboard_v2.next_steps.tasks.customize_link.description'),
		primaryActionText: translationKey('corgi.petition.starter_dashboard_v2.next_steps.tasks.customize_link.cta'),
	},
	share_friends: {
		title: translationKey('corgi.petition.starter_dashboard_v2.next_steps.tasks.share_friends.title'),
		description: translationKey('corgi.petition.starter_dashboard_v2.next_steps.tasks.share_friends.description'),
		primaryActionText: translationKey('corgi.petition.starter_dashboard_v2.next_steps.tasks.share_friends.cta'),
	},
	share_communities: {
		title: translationKey('corgi.petition.starter_dashboard_v2.next_steps.tasks.share_communities.title'),
		description: translationKey('corgi.petition.starter_dashboard_v2.next_steps.tasks.share_communities.description'),
		primaryActionText: translationKey('corgi.petition.starter_dashboard_v2.next_steps.tasks.share_communities.cta'),
	},
	share_facebook: {
		title: translationKey('corgi.petition.starter_dashboard_v2.next_steps.tasks.share_facebook.title'),
		description: translationKey('corgi.petition.starter_dashboard_v2.next_steps.tasks.share_facebook.description'),
		primaryActionText: translationKey('corgi.petition.starter_dashboard_v2.next_steps.tasks.share_facebook.cta'),
	},
	share_instagram: {
		title: translationKey('corgi.petition.starter_dashboard_v2.next_steps.tasks.share_instagram.title'),
		description: translationKey('corgi.petition.starter_dashboard_v2.next_steps.tasks.share_instagram.description'),
		primaryActionText: translationKey('corgi.petition.starter_dashboard_v2.next_steps.tasks.share_instagram.cta'),
	},
	download_flyer: {
		title: translationKey('corgi.petition.starter_dashboard_v2.next_steps.tasks.download_flyer.title'),
		description: translationKey('corgi.petition.starter_dashboard_v2.next_steps.tasks.download_flyer.description'),
		primaryActionText: translationKey('corgi.petition.starter_dashboard_v2.next_steps.tasks.download_flyer.cta'),
	},
	thank_supporters: {
		title: translationKey('corgi.petition.starter_dashboard_v2.next_steps.tasks.thank_supporters.title'),
		description: translationKey('corgi.petition.starter_dashboard_v2.next_steps.tasks.thank_supporters.description'),
		primaryActionText: translationKey('corgi.petition.starter_dashboard_v2.next_steps.tasks.thank_supporters.cta'),
	},
	promote_basic: {
		title: translationKey('corgi.petition.starter_dashboard_v2.next_steps.tasks.promote_basic.title'),
		description: translationKey('corgi.petition.starter_dashboard_v2.next_steps.tasks.promote_basic.description'),
		primaryActionText: translationKey('corgi.petition.starter_dashboard_v2.next_steps.tasks.promote_basic.cta'),
	},
};
